/**
 *
 *
 *
 *   EDITING THIS FILE REQUIRES EDITS TO EMAIL TEMPLATE PROJECT REPO FILE AS WELL TO KEEP THEM IN SYNC
 *
 *
 *
 *
 */

import {LOCALES} from '@utils/locales/locales';

export const PREEXPAT_TEMPLATE_DEFAULTS = {
  [LOCALES.EN]: {
    subject: 'Pre Expatriation Notification',
    components: [
      {
        order: 1,
        type: 'TITLE',
        html: 'Pre Expatriation Notification',
      },
      {
        order: 2,
        type: 'DIVIDER',
      },
      {
        order: 3,
        type: 'HTML',
        html: '<div><span class="customEmbed" data-key="First_Name" translate="no"><span contenteditable="false">&lt;First_Name&gt;</span></span>&nbsp;<span class="customEmbed" data-key="Last_Name" translate="no"><span contenteditable="false">&lt;Last_Name&gt;</span></span>,</div><div><br></div><div>You are scheduled to begin an expatriation to the below destination. Please see the latest advice for this destination along with any active alerts.</div>',
      },
      {
        order: 4,
        type: 'EXPAT_ASSIGNMENT_DETAILS',
        includeExpatriationName: true,
        includeExpatriationStartDate: true,
        includeExpatriationEndDate: true,
      },
      {
        order: 5,
        html: 'Destinations: city, country',
        includeLocationIntelligenceLinks: true,
        includeLocationCountryBriefLink: true,
        includeLocationCityBriefLink: true,
        type: 'DESTINATIONS',
      },
      {
        order: 6,
        type: 'DIVIDER',
      },
      {
        order: 7,
        type: 'HTML',
        html: 'You are receiving this notification because your organization has opted you into receiving pre expatriation notifications. For further questions about this notification please contact your organization’s expatriate risk management team or submit request for information to <a href="mailto:support@crisis24.com">support@crisis24.com</a>.',
      },
    ],
  },
  [LOCALES.FR]: {
    subject: "Notification préalable à l'expatriation",
    components: [
      {
        order: 1,
        type: 'TITLE',
        html: "Notification préalable à l'expatriation",
      },
      {
        order: 2,
        type: 'DIVIDER',
      },
      {
        order: 3,
        type: 'HTML',
        html: '<div><span class="customEmbed" data-key="First_Name" translate="no"><span contenteditable="false">&lt;First_Name&gt;</span></span>&nbsp;<span class="customEmbed" data-key="Last_Name" translate="no"><span contenteditable="false">&lt;Last_Name&gt;</span></span>,</div><div><br></div><div>Il est prévu que vous commenciez une expatriation vers la destination ci-dessous. Consultez les derniers conseils pour cette destination ainsi que les alertes actives.</div>',
      },
      {
        order: 4,
        type: 'EXPAT_ASSIGNMENT_DETAILS',
        includeExpatriationName: true,
        includeExpatriationStartDate: true,
        includeExpatriationEndDate: true,
      },
      {
        order: 5,
        html: 'Destinations: city, country',
        includeLocationIntelligenceLinks: true,
        includeLocationCountryBriefLink: true,
        includeLocationCityBriefLink: true,
        type: 'DESTINATIONS',
      },
      {
        order: 6,
        type: 'DIVIDER',
      },
      {
        order: 7,
        type: 'HTML',
        html: 'Vous recevez cette notification parce que votre organisation a choisi de vous envoyer des notifications de pré-expatriation. Pour toute autre question concernant cette notification, veuillez contacter l\'équipe de gestion des risques liés aux expatriés de votre organisation ou envoyez une demande d\'informations à <a href="mailto:support@crisis24.com">support@crisis24.com</a>.',
      },
    ],
  },
  [LOCALES.ES]: {
    subject: 'Notificación previa a la expatriación',
    components: [
      {
        order: 1,
        type: 'TITLE',
        html: 'Notificación previa a la expatriación',
      },
      {
        order: 2,
        type: 'DIVIDER',
      },
      {
        order: 3,
        type: 'HTML',
        html: '<div><span class="customEmbed" data-key="First_Name" translate="no"><span contenteditable="false">&lt;First_Name&gt;</span></span>&nbsp;<span class="customEmbed" data-key="Last_Name" translate="no"><span contenteditable="false">&lt;Last_Name&gt;</span></span>,</div><div><br></div><div>Tiene previsto viajar a los siguientes destinos. A continuación encontrará los consejos de viaje más recientes para estos destinos junto con las alertas activas.</div><div><br></div><div>Está recibiendo esta notificación porque su organización ha optado por que reciba notificaciones previas al viaje. Si tienes más preguntas sobre esta notificación, ponte en contacto con el equipo de gestión de riesgos de viaje de tu organización o envía una solicitud de información a <a href="mailto:support@crisis24.com" rel="noopener noreferrer" target="_blank">support@crisis24.com</a>.</div>',
      },
      {
        order: 4,
        type: 'EXPAT_ASSIGNMENT_DETAILS',
        includeExpatriationName: true,
        includeExpatriationStartDate: true,
        includeExpatriationEndDate: true,
      },
      {
        order: 5,
        html: 'Destinations: city, country',
        includeLocationIntelligenceLinks: true,
        includeLocationCountryBriefLink: true,
        includeLocationCityBriefLink: true,
        type: 'DESTINATIONS',
      },
      {
        order: 6,
        type: 'DIVIDER',
      },
      {
        order: 7,
        type: 'HTML',
        html: 'Recibe esta notificación porque su organización ha optado por recibir notificaciones previas a la expatriación. Si tiene más preguntas sobre esta notificación, póngase en contacto con el equipo de gestión de riesgos expatriado de su organización o envíe una solicitud de información a <a href="mailto:support@crisis24.com">support@crisis24.com</a>.',
      },
    ],
  },
  [LOCALES.DE]: {
    subject: 'Benachrichtigung vor dem Auslandsaufenthalt',
    components: [
      {
        order: 1,
        type: 'TITLE',
        html: 'Benachrichtigung vor dem Auslandsaufenthalt',
      },
      {
        order: 2,
        type: 'DIVIDER',
      },
      {
        order: 3,
        type: 'HTML',
        html: '<div><span class="customEmbed" data-key="First_Name" translate="no"><span contenteditable="false">&lt;First_Name&gt;</span></span>&nbsp;<span class="customEmbed" data-key="Last_Name" translate="no"><span contenteditable="false">&lt;Last_Name&gt;</span></span>,</div><div><br></div><div>Es ist geplant, eine Expatriierung an das unten angegebene Ziel zu beginnen. Bitte beachten Sie die neuesten Hinweise für dieses Reiseziel sowie alle aktiven Benachrichtigungen.</div>',
      },
      {
        order: 4,
        type: 'EXPAT_ASSIGNMENT_DETAILS',
        includeExpatriationName: true,
        includeExpatriationStartDate: true,
        includeExpatriationEndDate: true,
      },
      {
        order: 5,
        html: 'Destinations: city, country',
        includeLocationIntelligenceLinks: true,
        includeLocationCountryBriefLink: true,
        includeLocationCityBriefLink: true,
        type: 'DESTINATIONS',
      },
      {
        order: 6,
        type: 'DIVIDER',
      },
      {
        order: 7,
        type: 'HTML',
        html: 'Sie erhalten diese Benachrichtigung, weil Ihre Organisation Sie für den Empfang von Benachrichtigungen vor dem Auslandsaufenthalt ausgewählt hat. Bei weiteren Fragen zu dieser Benachrichtigung wenden Sie sich bitte an das Risikomanagementteam Ihrer Organisation für Expats oder senden Sie eine Informationsanfrage an <a href="mailto:support@crisis24.com">support@crisis24.com</a>.',
      },
    ],
  },
  [LOCALES.IT]: {
    subject: 'Notifica pre-espatrio',
    components: [
      {
        order: 1,
        type: 'TITLE',
        html: 'Notifica pre-espatrio',
      },
      {
        order: 2,
        type: 'DIVIDER',
      },
      {
        order: 3,
        type: 'HTML',
        html: '<div><span class="customEmbed" data-key="First_Name" translate="no"><span contenteditable="false">&lt;First_Name&gt;</span></span>&nbsp;<span class="customEmbed" data-key="Last_Name" translate="no"><span contenteditable="false">&lt;Last_Name&gt;</span></span>,</div><div><br></div><div>È previsto che inizi l\'espatrio verso la destinazione indicata di seguito. Consulta i consigli più recenti per questa destinazione insieme a eventuali avvisi attivi.</div>',
      },
      {
        order: 4,
        type: 'EXPAT_ASSIGNMENT_DETAILS',
        includeExpatriationName: true,
        includeExpatriationStartDate: true,
        includeExpatriationEndDate: true,
      },
      {
        order: 5,
        html: 'Destinations: city, country',
        includeLocationIntelligenceLinks: true,
        includeLocationCountryBriefLink: true,
        includeLocationCityBriefLink: true,
        type: 'DESTINATIONS',
      },
      {
        order: 6,
        type: 'DIVIDER',
      },
      {
        order: 7,
        type: 'HTML',
        html: 'Stai ricevendo questa notifica perché la tua organizzazione ha scelto di ricevere notifiche prima dell\'espatrio. Per ulteriori domande su questa notifica, contatta il team di gestione del rischio per gli espatriati della tua organizzazione o invia una richiesta di informazioni a <a href="mailto:support@crisis24.com">support@crisis24.com</a>.',
      },
    ],
  },
  [LOCALES.JA]: {
    subject: '海外赴任前通知',
    components: [
      {
        order: 1,
        type: 'TITLE',
        html: '海外赴任前通知',
      },
      {
        order: 2,
        type: 'DIVIDER',
      },
      {
        order: 3,
        type: 'HTML',
        html: '<div><span class="customEmbed" data-key="First_Name" translate="no"><span contenteditable="false">&lt;First_Name&gt;</span></span>&nbsp;<span class="customEmbed" data-key="Last_Name" translate="no"><span contenteditable="false">&lt;Last_Name&gt;</span></span>,</div><div><br></div><div>下記の目的地への駐在を開始する予定です。この宛先に関する最新のアドバイスと、アクティブなアラートを確認してください。</div>',
      },
      {
        order: 4,
        type: 'EXPAT_ASSIGNMENT_DETAILS',
        includeExpatriationName: true,
        includeExpatriationStartDate: true,
        includeExpatriationEndDate: true,
      },
      {
        order: 5,
        html: 'Destinations: city, country',
        includeLocationIntelligenceLinks: true,
        includeLocationCountryBriefLink: true,
        includeLocationCityBriefLink: true,
        type: 'DESTINATIONS',
      },
      {
        order: 6,
        type: 'DIVIDER',
      },
      {
        order: 7,
        type: 'HTML',
        html: 'この通知を受け取っているのは、所属する組織が駐在前通知の受信を選択したためです。この通知についてさらに質問がある場合は、組織の駐在員リスク管理チームに連絡するか、<a href="mailto:support@crisis24.com">support@crisis24.com</a> に情報リクエストを送信してください。',
      },
    ],
  },
  [LOCALES.PT]: {
    subject: 'Notificação de pré-expatriação',
    components: [
      {
        order: 1,
        type: 'TITLE',
        html: 'Notificação de pré-expatriação',
      },
      {
        order: 2,
        type: 'DIVIDER',
      },
      {
        order: 3,
        type: 'HTML',
        html: '<div><span class="customEmbed" data-key="First_Name" translate="no"><span contenteditable="false">&lt;First_Name&gt;</span></span>&nbsp;<span class="customEmbed" data-key="Last_Name" translate="no"><span contenteditable="false">&lt;Last_Name&gt;</span></span>,</div><div><br></div><div>Você está programado para iniciar uma expatriação para o destino abaixo. Consulte os conselhos mais recentes para este destino junto com todos os alertas ativos.</div>',
      },
      {
        order: 4,
        type: 'EXPAT_ASSIGNMENT_DETAILS',
        includeExpatriationName: true,
        includeExpatriationStartDate: true,
        includeExpatriationEndDate: true,
      },
      {
        order: 5,
        html: 'Destinations: city, country',
        includeLocationIntelligenceLinks: true,
        includeLocationCountryBriefLink: true,
        includeLocationCityBriefLink: true,
        type: 'DESTINATIONS',
      },
      {
        order: 6,
        type: 'DIVIDER',
      },
      {
        order: 7,
        type: 'HTML',
        html: 'Você está recebendo essa notificação porque sua organização optou por receber notificações de pré-expatriação. Para mais perguntas sobre essa notificação, entre em contato com a equipe de gerenciamento de riscos de expatriados da sua organização ou envie uma solicitação de informações para <a href="mailto:support@crisis24.com">support@crisis24.com</a>.',
      },
    ],
  },
  [LOCALES.ZH_HANS]: {
    subject: '出国前通知',
    components: [
      {
        order: 1,
        type: 'TITLE',
        html: '出国前通知',
      },
      {
        order: 2,
        type: 'DIVIDER',
      },
      {
        order: 3,
        type: 'HTML',
        html: '<div><span class="customEmbed" data-key="First_Name" translate="no"><span contenteditable="false">&lt;First_Name&gt;</span></span>&nbsp;<span class="customEmbed" data-key="Last_Name" translate="no"><span contenteditable="false">&lt;Last_Name&gt;</span></span>,</div><div><br></div><div>您计划开始移居到以下目的地。请查看有关该目的地的最新建议以及任何有效的警报。</div>',
      },
      {
        order: 4,
        type: 'EXPAT_ASSIGNMENT_DETAILS',
        includeExpatriationName: true,
        includeExpatriationStartDate: true,
        includeExpatriationEndDate: true,
      },
      {
        order: 5,
        html: 'Destinations: city, country',
        includeLocationIntelligenceLinks: true,
        includeLocationCountryBriefLink: true,
        includeLocationCityBriefLink: true,
        type: 'DESTINATIONS',
      },
      {
        order: 6,
        type: 'DIVIDER',
      },
      {
        order: 7,
        type: 'HTML',
        html: '您之所以收到此通知，是因为您的组织已选择您接收离国前的通知。有关此通知的更多问题，请联系您所在组织的外籍人士风险管理团队或向 <a href="mailto:support@crisis24.com">support@crisis24.com</a> 提交信息请求。',
      },
    ],
  },
  [LOCALES.ZH_HANT]: {
    subject: '外籍前通知',
    components: [
      {
        order: 1,
        type: 'TITLE',
        html: '外籍前通知',
      },
      {
        order: 2,
        type: 'DIVIDER',
      },
      {
        order: 3,
        type: 'HTML',
        html: '<div><span class="customEmbed" data-key="First_Name" translate="no"><span contenteditable="false">&lt;First_Name&gt;</span></span>&nbsp;<span class="customEmbed" data-key="Last_Name" translate="no"><span contenteditable="false">&lt;Last_Name&gt;</span></span>,</div><div><br></div><div>您預定開始外籍人士前往以下目的地。請查看有關此目的地的最新建議以及任何有效的警報。</div>',
      },
      {
        order: 4,
        type: 'EXPAT_ASSIGNMENT_DETAILS',
        includeExpatriationName: true,
        includeExpatriationStartDate: true,
        includeExpatriationEndDate: true,
      },
      {
        order: 5,
        html: 'Destinations: city, country',
        includeLocationIntelligenceLinks: true,
        includeLocationCountryBriefLink: true,
        includeLocationCityBriefLink: true,
        type: 'DESTINATIONS',
      },
      {
        order: 6,
        type: 'DIVIDER',
      },
      {
        order: 7,
        type: 'HTML',
        html: '您收到此通知是因為您的組織已選擇您接收外籍前通知。如需有關此通知的進一步問題，請聯絡貴組織的外籍風險管理團隊，或將資訊提交至 <a href="mailto:support@crisis24.com">support@crisis24.com</a>。',
      },
    ],
  },
  [LOCALES.NL]: {
    subject: 'Melding vóór vertrek',
    components: [
      {
        order: 1,
        type: 'TITLE',
        html: 'Melding vóór vertrek',
      },
      {
        order: 2,
        type: 'DIVIDER',
      },
      {
        order: 3,
        type: 'HTML',
        html: '<div><span class="customEmbed" data-key="First_Name" translate="no"><span contenteditable="false">&lt;First_Name&gt;</span></span>&nbsp;<span class="customEmbed" data-key="Last_Name" translate="no"><span contenteditable="false">&lt;Last_Name&gt;</span></span>,</div><div><br></div><div>Het is de bedoeling dat u begint te emigreren naar de onderstaande bestemming. Raadpleeg het meest recente advies voor deze bestemming, samen met eventuele actieve meldingen.</div>',
      },
      {
        order: 4,
        type: 'EXPAT_ASSIGNMENT_DETAILS',
        includeExpatriationName: true,
        includeExpatriationStartDate: true,
        includeExpatriationEndDate: true,
      },
      {
        order: 5,
        html: 'Destinations: city, country',
        includeLocationIntelligenceLinks: true,
        includeLocationCountryBriefLink: true,
        includeLocationCityBriefLink: true,
        type: 'DESTINATIONS',
      },
      {
        order: 6,
        type: 'DIVIDER',
      },
      {
        order: 7,
        type: 'HTML',
        html: 'U ontvangt deze melding omdat uw organisatie ervoor heeft gekozen om meldingen vóór uw vertrek te ontvangen. Voor verdere vragen over deze melding kunt u contact opnemen met het risicomanagementteam voor expats van uw organisatie of een verzoek om informatie indienen bij <a href="mailto:support@crisis24.com">support@crisis24.com</a>.',
      },
    ],
  },
  [LOCALES.HI]: {
    subject: 'प्री निर्वासन नोटिफिकेशन',
    components: [
      {
        order: 1,
        type: 'TITLE',
        html: 'प्री निर्वासन नोटिफिकेशन',
      },
      {
        order: 2,
        type: 'DIVIDER',
      },
      {
        order: 3,
        type: 'HTML',
        html: '<div><span class="customEmbed" data-key="First_Name" translate="no"><span contenteditable="false">&lt;First_Name&gt;</span></span>&nbsp;<span class="customEmbed" data-key="Last_Name" translate="no"><span contenteditable="false">&lt;Last_Name&gt;</span></span>,</div><div><br></div><div>आप नीचे दिए गए गंतव्य के लिए एक प्रवासी शुरू करने वाले हैं। कृपया किसी भी सक्रिय अलर्ट के साथ इस गंतव्य के लिए नवीनतम सलाह देखें।</div>',
      },
      {
        order: 4,
        type: 'EXPAT_ASSIGNMENT_DETAILS',
        includeExpatriationName: true,
        includeExpatriationStartDate: true,
        includeExpatriationEndDate: true,
      },
      {
        order: 5,
        html: 'Destinations: city, country',
        includeLocationIntelligenceLinks: true,
        includeLocationCountryBriefLink: true,
        includeLocationCityBriefLink: true,
        type: 'DESTINATIONS',
      },
      {
        order: 6,
        type: 'DIVIDER',
      },
      {
        order: 7,
        type: 'HTML',
        html: 'आपको यह सूचना इसलिए मिल रही है क्योंकि आपके संगठन ने आपको प्रवास-पूर्व सूचनाएं प्राप्त करने का विकल्प चुना है। इस सूचना के बारे में और प्रश्नों के लिए कृपया अपने संगठन की प्रवासी जोखिम प्रबंधन टीम से संपर्क करें या <a href="mailto:support@crisis24.com">support@crisis24.com</a> पर जानकारी के लिए अनुरोध सबमिट करें।',
      },
    ],
  },
  [LOCALES.RU]: {
    subject: 'Уведомление перед поездкой',
    components: [
      {
        order: 1,
        type: 'TITLE',
        html: 'Уведомление перед поездкой',
      },
      {
        order: 2,
        type: 'DIVIDER',
      },
      {
        order: 3,
        type: 'HTML',
        html: '<div><span class="customEmbed" data-key="First_Name" translate="no"><span contenteditable="false">&lt;First_Name&gt;</span></span>&nbsp;<span class="customEmbed" data-key="Last_Name" translate="no"><span contenteditable="false">&lt;Last_Name&gt;</span></span>,</div><div><br></div><div>Вы планируете отправиться в указанные ниже пункты назначения. Ниже вы найдете последние рекомендации по путешествиям по этим направлениям, а также все активные уведомления.</div><div><br></div><div>Планируется, что вы начнете экспатриацию в указанное ниже место назначения. Пожалуйста, ознакомьтесь с последними рекомендациями по этому направлению, а также с любыми активными оповещениями.</div>',
      },
      {
        order: 4,
        type: 'EXPAT_ASSIGNMENT_DETAILS',
        includeExpatriationName: true,
        includeExpatriationStartDate: true,
        includeExpatriationEndDate: true,
      },
      {
        order: 5,
        html: 'Destinations: city, country',
        includeLocationIntelligenceLinks: true,
        includeLocationCountryBriefLink: true,
        includeLocationCityBriefLink: true,
        type: 'DESTINATIONS',
      },
      {
        order: 6,
        type: 'DIVIDER',
      },
      {
        order: 7,
        type: 'HTML',
        html: 'Вы получили это уведомление, потому что ваша организация разрешила вам получать уведомления до экспатриации. Если у вас возникнут дополнительные вопросы по этому уведомлению, обратитесь в отдел управления рисками, связанными с экспатриантами в вашей организации, или отправьте запрос на получение информации по адресу <a href="mailto:support@crisis24.com">support@crisis24.com</a>.',
      },
    ],
  },
  [LOCALES.PL]: {
    subject: 'Powiadomienie przed emigracją',
    components: [
      {
        order: 1,
        type: 'TITLE',
        html: 'Powiadomienie przed emigracją',
      },
      {
        order: 2,
        type: 'DIVIDER',
      },
      {
        order: 3,
        type: 'HTML',
        html: '<div><span class="customEmbed" data-key="First_Name" translate="no"><span contenteditable="false">&lt;First_Name&gt;</span></span>&nbsp;<span class="customEmbed" data-key="Last_Name" translate="no"><span contenteditable="false">&lt;Last_Name&gt;</span></span>,</div><div><br></div><div>Planujesz rozpocząć emigrację do poniższego miejsca docelowego. Zapoznaj się z najnowszymi poradami dotyczącymi tego miejsca docelowego wraz z aktywnymi alertami.</div>',
      },
      {
        order: 4,
        type: 'EXPAT_ASSIGNMENT_DETAILS',
        includeExpatriationName: true,
        includeExpatriationStartDate: true,
        includeExpatriationEndDate: true,
      },
      {
        order: 5,
        html: 'Destinations: city, country',
        includeLocationIntelligenceLinks: true,
        includeLocationCountryBriefLink: true,
        includeLocationCityBriefLink: true,
        type: 'DESTINATIONS',
      },
      {
        order: 6,
        type: 'DIVIDER',
      },
      {
        order: 7,
        type: 'HTML',
        html: 'Otrzymujesz to powiadomienie, ponieważ Twoja organizacja zdecydowała się na otrzymywanie powiadomień przed ekspatriacją. W przypadku dalszych pytań dotyczących tego powiadomienia należy skontaktować się z zespołem ds. zarządzania ryzykiem za granicą lub przesłać prośbę o udzielenie informacji na adres <a href="mailto:support@crisis24.com">support@crisis24.com</a>.',
      },
    ],
  },
  [LOCALES.HE]: {
    subject: 'הודעת טרום הגירה',
    components: [
      {
        order: 1,
        type: 'TITLE',
        html: 'הודעת טרום הגירה',
      },
      {
        order: 2,
        type: 'DIVIDER',
      },
      {
        order: 3,
        type: 'HTML',
        html: '<div><span class="customEmbed" data-key="First_Name" translate="no"><span contenteditable="false">&lt;שם פרטי&gt;</span></span>&nbsp;<span class="customEmbed" data-key="Last_Name" translate="no"><span contenteditable="false">&lt;שם משפחה&gt;</span></span>,</div><div><br></div><div>אתה אמור להתחיל בגלות ליעד למטה. אנא עיין בעצות העדכניות ביותר עבור יעד זה יחד עם כל התראות פעילות.</div>',
      },
      {
        order: 4,
        type: 'EXPAT_ASSIGNMENT_DETAILS',
        includeExpatriationName: true,
        includeExpatriationStartDate: true,
        includeExpatriationEndDate: true,
      },
      {
        order: 5,
        html: 'Destinations: city, country',
        includeLocationIntelligenceLinks: true,
        includeLocationCountryBriefLink: true,
        includeLocationCityBriefLink: true,
        type: 'DESTINATIONS',
      },
      {
        order: 6,
        type: 'DIVIDER',
      },
      {
        order: 7,
        type: 'HTML',
        html: 'אתה מקבל הודעה זו מכיוון שהארגון שלך בחר לך לקבל הודעות לפני הגירה. לשאלות נוספות בנוגע להודעה זו אנא צרו קשר עם צוות ניהול הסיכונים הגולים בארגון שלכם או הגשו בקשה לקבלת מידע אל <a href="mailto:support@crisis24.com">support@crisis24.com</a>.',
      },
    ],
  },
  [LOCALES.TR]: {
    subject: 'Göçmenlik Öncesi Bildirim',
    components: [
      {
        order: 1,
        type: 'TITLE',
        html: 'Göçmenlik Öncesi Bildirim',
      },
      {
        order: 2,
        type: 'DIVIDER',
      },
      {
        order: 3,
        type: 'HTML',
        html: '<div><span class="customEmbed" data-key="First_Name" translate="no"><span contenteditable="false">&lt;First_Name&gt;</span></span> <span class="customEmbed" data-key="Last_Name" translate="no"><span contenteditable="false">&lt;Last_Name&gt;</span></span>,<div></div></div> <br><div>Aşağıdaki hedefe göçmenlik yapmaya başlamanız planlanıyor. Lütfen aktif uyarılarla birlikte bu varış yeri için en son tavsiyelere bakın.</div>',
      },
      {
        order: 4,
        type: 'EXPAT_ASSIGNMENT_DETAILS',
        includeExpatriationName: true,
        includeExpatriationStartDate: true,
        includeExpatriationEndDate: true,
      },
      {
        order: 5,
        html: 'Destinations: city, country',
        includeLocationIntelligenceLinks: true,
        includeLocationCountryBriefLink: true,
        includeLocationCityBriefLink: true,
        type: 'DESTINATIONS',
      },
      {
        order: 6,
        type: 'DIVIDER',
      },
      {
        order: 7,
        type: 'HTML',
        html: 'Kuruluşunuz sizi göçmenlik öncesi bildirimler almayı seçtiği için bu bildirimi alıyorsunuz. <a href="mailto:support@crisis24.com">Bu bildirimle ilgili başka sorularınız için lütfen kuruluşunuzun gurbetçi risk yönetimi ekibiyle iletişime geçin veya bilgi talebi support@crisis24.com adresine gönderin.</a>',
      },
    ],
  },
  [LOCALES.KO]: {
    subject: '해외 체류 전 신고',
    components: [
      {
        order: 1,
        type: 'TITLE',
        html: '해외 체류 전 신고',
      },
      {
        order: 2,
        type: 'DIVIDER',
      },
      {
        order: 3,
        type: 'HTML',
        html: '<div><span class="customEmbed" data-key="First_Name" translate="no"><span contenteditable="false">&lt;First_Name&gt;</span></span> <span class="customEmbed" data-key="Last_Name" translate="no"><span contenteditable="false">&lt;Last_Name&gt;</span></span>,<div></div></div> <br><div>아래 목적지로 해외 이주를 시작할 예정입니다.현재 진행 중인 알림과 함께 해당 목적지에 대한 최신 정보를 참조하십시오</div>.',
      },
      {
        order: 4,
        type: 'EXPAT_ASSIGNMENT_DETAILS',
        includeExpatriationName: true,
        includeExpatriationStartDate: true,
        includeExpatriationEndDate: true,
      },
      {
        order: 5,
        html: 'Destinations: city, country',
        includeLocationIntelligenceLinks: true,
        includeLocationCountryBriefLink: true,
        includeLocationCityBriefLink: true,
        type: 'DESTINATIONS',
      },
      {
        order: 6,
        type: 'DIVIDER',
      },
      {
        order: 7,
        type: 'HTML',
        html: '귀사가 해외 이주 전 통지를 수신하도록 선택했기 때문에 이 알림을 받는 것입니다.<a href="mailto:support@crisis24.com">이 알림에 대한 추가 질문은 조직의 외국인 위험 관리 팀에 문의하거나 support@crisis24.com 으로 정보 요청을 제출하십시오.</a>',
      },
    ],
  },
  [LOCALES.EL]: {
    subject: 'Ειδοποίηση πριν από την αποδημία',
    components: [
      {
        order: 1,
        type: 'TITLE',
        html: 'Ειδοποίηση πριν από την αποδημία',
      },
      {
        order: 2,
        type: 'DIVIDER',
      },
      {
        order: 3,
        type: 'HTML',
        html: '<div><span class="customEmbed" data-key="First_Name" translate="no"><span contenteditable="false">&lt;First_Name&gt;</span></span> <span class="customEmbed" data-key="Last_Name" translate="no"><span contenteditable="false">&lt;Last_Name&gt;</span></span>,<div></div></div> <br><div>Έχετε προγραμματίσει να ξεκινήσετε έναν απόδημο στον παρακάτω προορισμό. Ανατρέξτε στις πιο πρόσφατες συμβουλές για αυτόν τον προορισμό μαζί με τυχόν ενεργές ειδοποιήσεις.</div>',
      },
      {
        order: 4,
        type: 'EXPAT_ASSIGNMENT_DETAILS',
        includeExpatriationName: true,
        includeExpatriationStartDate: true,
        includeExpatriationEndDate: true,
      },
      {
        order: 5,
        html: 'Destinations: city, country',
        includeLocationIntelligenceLinks: true,
        includeLocationCountryBriefLink: true,
        includeLocationCityBriefLink: true,
        type: 'DESTINATIONS',
      },
      {
        order: 6,
        type: 'DIVIDER',
      },
      {
        order: 7,
        type: 'HTML',
        html: 'Λαμβάνετε αυτήν την ειδοποίηση επειδή ο οργανισμός σας έχει επιλέξει να λαμβάνετε ειδοποιήσεις πριν από την αποδημία. <a href="mailto:support@crisis24.com">Για περισσότερες ερωτήσεις σχετικά με αυτήν την ειδοποίηση, επικοινωνήστε με την ομάδα διαχείρισης κινδύνου εκπατρισμένων του οργανισμού σας ή υποβάλετε αίτημα για πληροφορίες στο support@crisis24.com.</a>',
      },
    ],
  },
  [LOCALES.VI]: {
    subject: 'Thông báo trước khi ra nước ngoài',
    components: [
      {
        order: 1,
        type: 'TITLE',
        html: 'Thông báo trước khi ra nước ngoài',
      },
      {
        order: 2,
        type: 'DIVIDER',
      },
      {
        order: 3,
        type: 'HTML',
        html: '<div><span class="customEmbed" data-key="First_Name" translate="no"><span contenteditable="false">&lt;First_Name&gt;</span></span> <span class="customEmbed" data-key="Last_Name" translate="no"><span contenteditable="false">&lt;Last_Name&gt;</span></span>,<div></div> Bạn</div> <br><div>được lên lịch để bắt đầu một cuộc xuất cảnh đến điểm đến dưới đây. Vui lòng xem lời khuyên mới nhất cho điểm đến này cùng với bất kỳ cảnh báo đang hoạt động nào.</div>',
      },
      {
        order: 4,
        type: 'EXPAT_ASSIGNMENT_DETAILS',
        includeExpatriationName: true,
        includeExpatriationStartDate: true,
        includeExpatriationEndDate: true,
      },
      {
        order: 5,
        html: 'Destinations: city, country',
        includeLocationIntelligenceLinks: true,
        includeLocationCountryBriefLink: true,
        includeLocationCityBriefLink: true,
        type: 'DESTINATIONS',
      },
      {
        order: 6,
        type: 'DIVIDER',
      },
      {
        order: 7,
        type: 'HTML',
        html: 'Bạn đang nhận được thông báo này vì tổ chức của bạn đã chọn bạn nhận thông báo trước khi ra nước ngoài. <a href="mailto:support@crisis24.com">Nếu có thêm câu hỏi về thông báo này, vui lòng liên hệ với nhóm quản lý rủi ro người nước ngoài của tổ chức bạn hoặc gửi yêu cầu cung cấp thông tin đến support@crisis24.com.</a>',
      },
    ],
  },
  [LOCALES.CS]: {
    subject: 'Oznámení před emigrací',
    components: [
      {
        order: 1,
        type: 'TITLE',
        html: 'Oznámení před emigrací',
      },
      {
        order: 2,
        type: 'DIVIDER',
      },
      {
        order: 3,
        type: 'HTML',
        html: '<div><span class="customEmbed" data-key="First_Name" translate="no"><span contenteditable="false">&lt;First_Name&gt;</span></span> <span class="customEmbed" data-key="Last_Name" translate="no"><span contenteditable="false">&lt;Last_Name&gt;</span></span>,<div></div></div> <br><div>Je naplánováno zahájení expatriace do níže uvedeného cíle. Přečtěte si nejnovější rady pro tento cíl spolu s aktivními upozorněními.</div>',
      },
      {
        order: 4,
        type: 'EXPAT_ASSIGNMENT_DETAILS',
        includeExpatriationName: true,
        includeExpatriationStartDate: true,
        includeExpatriationEndDate: true,
      },
      {
        order: 5,
        html: 'Destinations: city, country',
        includeLocationIntelligenceLinks: true,
        includeLocationCountryBriefLink: true,
        includeLocationCityBriefLink: true,
        type: 'DESTINATIONS',
      },
      {
        order: 6,
        type: 'DIVIDER',
      },
      {
        order: 7,
        type: 'HTML',
        html: 'Toto oznámení dostáváte, protože vaše organizace vás rozhodla přijímat oznámení před expatriací. <a href="mailto:support@crisis24.com">Máte-li další dotazy týkající se tohoto oznámení, obraťte se na tým pro řízení rizik v zahraničí vaší organizace nebo odešlete žádost o informace na adresu support@crisis24.com.</a>',
      },
    ],
  },
  [LOCALES.HU]: {
    subject: 'Expedíció előtti értesítés',
    components: [
      {
        order: 1,
        type: 'TITLE',
        html: 'Expedíció előtti értesítés',
      },
      {
        order: 2,
        type: 'DIVIDER',
      },
      {
        order: 3,
        type: 'HTML',
        html: '<div><span class="customEmbed" data-key="First_Name" translate="no"><span contenteditable="false">&lt;First_Name&gt;</span></span> <span class="customEmbed" data-key="Last_Name" translate="no"><span contenteditable="false">&lt;Last_Name&gt;</span></span>,</div> A<div></div> <br><div>tervek szerint elkezdi az emigrációt az alábbi célállomásra. Kérjük, olvassa el az úti céllal kapcsolatos legfrissebb tanácsokat az aktív figyelmeztetésekkel együtt.</div>',
      },
      {
        order: 4,
        type: 'EXPAT_ASSIGNMENT_DETAILS',
        includeExpatriationName: true,
        includeExpatriationStartDate: true,
        includeExpatriationEndDate: true,
      },
      {
        order: 5,
        html: 'Destinations: city, country',
        includeLocationIntelligenceLinks: true,
        includeLocationCountryBriefLink: true,
        includeLocationCityBriefLink: true,
        type: 'DESTINATIONS',
      },
      {
        order: 6,
        type: 'DIVIDER',
      },
      {
        order: 7,
        type: 'HTML',
        html: 'Ezt az értesítést azért kapja meg, mert szervezete választotta Önt az expedíció előtti értesítések fogadására. Ha további kérdései vannak ezzel az értesítéssel kapcsolatban, kérjük, vegye fel a kapcsolatot a szervezet külföldi kockázatkezelő csapatával, vagy küldjön tájékoztatási kérelmet a <a href="mailto:support@crisis24.com">support@crisis24.com címre</a>.',
      },
    ],
  },
  [LOCALES.MS]: {
    subject: 'Pemberitahuan Pra-Ekspatriasi',
    components: [
      {
        order: 1,
        type: 'TITLE',
        html: 'Pemberitahuan Pra-Ekspatriasi',
      },
      {
        order: 2,
        type: 'DIVIDER',
      },
      {
        order: 3,
        type: 'HTML',
        html: '<div><span class="customEmbed" data-key="First_Name" translate="no"><span contenteditable="false">&lt;First_Name&gt;</span></span> <span class="customEmbed" data-key="Last_Name" translate="no"><span contenteditable="false">&lt;Last_Name&gt;</span></span>,<div></div> Anda</div> <br><div>dijadualkan untuk memulakan ekspatriasi ke destinasi di bawah. Sila lihat nasihat terkini untuk destinasi ini bersama-sama dengan sebarang makluman aktif.</div>',
      },
      {
        order: 4,
        type: 'EXPAT_ASSIGNMENT_DETAILS',
        includeExpatriationName: true,
        includeExpatriationStartDate: true,
        includeExpatriationEndDate: true,
      },
      {
        order: 5,
        html: 'Destinations: city, country',
        includeLocationIntelligenceLinks: true,
        includeLocationCountryBriefLink: true,
        includeLocationCityBriefLink: true,
        type: 'DESTINATIONS',
      },
      {
        order: 6,
        type: 'DIVIDER',
      },
      {
        order: 7,
        type: 'HTML',
        html: 'Anda menerima pemberitahuan ini kerana organisasi anda telah memilih anda untuk menerima pemberitahuan pra-ekspatriasi. Untuk pertanyaan lanjut mengenai pemberitahuan ini sila hubungi pasukan pengurusan risiko ekspatriat organisasi anda atau hantar permintaan maklumat kepada <a href="mailto:support@crisis24.com">support@crisis24.com</a>.',
      },
    ],
  },
  [LOCALES.RO]: {
    subject: 'Notificare pre-expatriere',
    components: [
      {
        order: 1,
        type: 'TITLE',
        html: 'Notificare pre-expatriere',
      },
      {
        order: 2,
        type: 'DIVIDER',
      },
      {
        order: 3,
        type: 'HTML',
        html: '<div><span class="customEmbed" data-key="First_Name" translate="no"><span contenteditable="false">&lt;First_Name&gt;</span></span> <span class="customEmbed" data-key="Last_Name" translate="no"><span contenteditable="false">&lt;Last_Name&gt;</span></span>, Sun<div></div></div> <br><div>teți programat să începeți o expatriere la destinația de mai jos. Vă rugăm să consultați cele mai recente sfaturi pentru această destinație împreună cu orice alerte active.</div>',
      },
      {
        order: 4,
        type: 'EXPAT_ASSIGNMENT_DETAILS',
        includeExpatriationName: true,
        includeExpatriationStartDate: true,
        includeExpatriationEndDate: true,
      },
      {
        order: 5,
        html: 'Destinations: city, country',
        includeLocationIntelligenceLinks: true,
        includeLocationCountryBriefLink: true,
        includeLocationCityBriefLink: true,
        type: 'DESTINATIONS',
      },
      {
        order: 6,
        type: 'DIVIDER',
      },
      {
        order: 7,
        type: 'HTML',
        html: 'Primiți această notificare deoarece organizația dvs. v-a optat pentru primirea notificărilor pre-expatriere. <a href="mailto:support@crisis24.com">Pentru întrebări suplimentare cu privire la această notificare, vă rugăm să contactați echipa de gestionare a riscurilor expatriați a organizației dvs. sau trimiteți solicitarea de informații la support@crisis24.com.</a>',
      },
    ],
  },
  [LOCALES.SK]: {
    subject: 'Oznámenie pred expedíciou',
    components: [
      {
        order: 1,
        type: 'TITLE',
        html: 'Oznámenie pred expedíciou',
      },
      {
        order: 2,
        type: 'DIVIDER',
      },
      {
        order: 3,
        type: 'HTML',
        html: '<div><span class="customEmbed" data-key="First_Name" translate="no"><span contenteditable="false">&lt;First_Name&gt;</span></span> <span class="customEmbed" data-key="Last_Name" translate="no"><span contenteditable="false">&lt;Last_Name&gt;</span></span>, Má<div></div></div> <br><div>te naplánované začatie expedície do nižšie uvedeného cieľa. Pozrite si najnovšie rady pre túto destináciu spolu s aktívnymi upozorneniami.</div>',
      },
      {
        order: 4,
        type: 'EXPAT_ASSIGNMENT_DETAILS',
        includeExpatriationName: true,
        includeExpatriationStartDate: true,
        includeExpatriationEndDate: true,
      },
      {
        order: 5,
        html: 'Destinations: city, country',
        includeLocationIntelligenceLinks: true,
        includeLocationCountryBriefLink: true,
        includeLocationCityBriefLink: true,
        type: 'DESTINATIONS',
      },
      {
        order: 6,
        type: 'DIVIDER',
      },
      {
        order: 7,
        type: 'HTML',
        html: 'Toto upozornenie dostávate, pretože vaša organizácia vám povolila prijímať upozornenia pred expedíciou. V prípade ďalších otázok týkajúcich sa tohto oznámenia kontaktujte tím riadenia rizík vo vašej organizácii alebo odošlite žiadosť o informácie na <a href="mailto:support@crisis24.com">adresu support@crisis24.com</a>.',
      },
    ],
  },
  [LOCALES.TH]: {
    subject: 'การแจ้งเตือนก่อนการอพยพ',
    components: [
      {
        order: 1,
        type: 'TITLE',
        html: 'การแจ้งเตือนก่อนการอพยพ',
      },
      {
        order: 2,
        type: 'DIVIDER',
      },
      {
        order: 3,
        type: 'HTML',
        html: '<div><span class="customEmbed" data-key="First_Name" translate="no"><span contenteditable="false">&lt;First_Name&gt;</span></span> <span class="customEmbed" data-key="Last_Name" translate="no"><span contenteditable="false">&lt;Last_Name&gt;</span></span><div></div> คุณ</div> <br><div>มีกำหนดเวลาที่จะเริ่มการเดินทางไปยังปลายทางด้านล่างโปรดดูคำแนะนำล่าสุดสำหรับจุดหมายปลายทางนี้พร้อมกับการแจ้งเตือนที่ใช้งานอยู่</div>',
      },
      {
        order: 4,
        type: 'EXPAT_ASSIGNMENT_DETAILS',
        includeExpatriationName: true,
        includeExpatriationStartDate: true,
        includeExpatriationEndDate: true,
      },
      {
        order: 5,
        html: 'Destinations: city, country',
        includeLocationIntelligenceLinks: true,
        includeLocationCountryBriefLink: true,
        includeLocationCityBriefLink: true,
        type: 'DESTINATIONS',
      },
      {
        order: 6,
        type: 'DIVIDER',
      },
      {
        order: 7,
        type: 'HTML',
        html: 'คุณกำลังได้รับการแจ้งเตือนนี้เนื่องจากองค์กรของคุณได้เลือกให้คุณรับการแจ้งเตือนก่อนการออกถิ่นฐานสำหรับคำถามเพิ่มเติมเกี่ยวกับการแจ้งเตือนนี้ โปรดติดต่อทีมบริหารความเสี่ยงจากต่างประเทศขององค์กรของคุณ หรือส่งคำขอข้อมูลไปที่ <a href="mailto:support@crisis24.com">support@crisis24.com</a>',
      },
    ],
  },
  [LOCALES.UK]: {
    subject: 'Повідомлення про попередню еміграцію',
    components: [
      {
        order: 1,
        type: 'TITLE',
        html: 'Повідомлення про попередню еміграцію',
      },
      {
        order: 2,
        type: 'DIVIDER',
      },
      {
        order: 3,
        type: 'HTML',
        html: '<div><span class="customEmbed" data-key="First_Name" translate="no"><span contenteditable="false">&lt;First_Name&gt;</span></span> <span class="customEmbed" data-key="Last_Name" translate="no"><span contenteditable="false">&lt;Last_Name&gt;</span></span>,<div></div> Ви</div> <br><div>плануєте розпочати еміграцію до нижченаведеного пункту призначення. Будь ласка, перегляньте останні поради щодо цього пункту призначення разом із будь-якими активними сповіщеннями.</div>',
      },
      {
        order: 4,
        type: 'EXPAT_ASSIGNMENT_DETAILS',
        includeExpatriationName: true,
        includeExpatriationStartDate: true,
        includeExpatriationEndDate: true,
      },
      {
        order: 5,
        html: 'Destinations: city, country',
        includeLocationIntelligenceLinks: true,
        includeLocationCountryBriefLink: true,
        includeLocationCityBriefLink: true,
        type: 'DESTINATIONS',
      },
      {
        order: 6,
        type: 'DIVIDER',
      },
      {
        order: 7,
        type: 'HTML',
        html: 'Ви отримуєте це сповіщення, оскільки ваша організація вирішила отримувати сповіщення перед еміграцією. <a href="mailto:support@crisis24.com">Для отримання додаткових запитань щодо цього повідомлення, будь ласка, зв\'яжіться з командою управління ризиками емігрантів вашої організації або надішліть запит на отримання інформації на адресу support@crisis24.com.</a>',
      },
    ],
  },
  [LOCALES.BG]: {
    subject: 'Предварително уведомление за експедиция',
    components: [
      {
        order: 1,
        type: 'TITLE',
        html: 'Предварително уведомление за експедиция',
      },
      {
        order: 2,
        type: 'DIVIDER',
      },
      {
        order: 3,
        type: 'HTML',
        html: '<div><span class="customEmbed" data-key="First_Name" translate="no"><span contenteditable="false">&lt;First_Name&gt;</span></span> <span class="customEmbed" data-key="Last_Name" translate="no"><span contenteditable="false">&lt;Last_Name&gt;</span></span>,<div></div></div> <br><div>Планирано е да започнете експедиция до дестинацията по-долу. Моля, вижте най-новите съвети за тази дестинация заедно с всички активни сигнали.</div>',
      },
      {
        order: 4,
        type: 'EXPAT_ASSIGNMENT_DETAILS',
        includeExpatriationName: true,
        includeExpatriationStartDate: true,
        includeExpatriationEndDate: true,
      },
      {
        order: 5,
        html: 'Destinations: city, country',
        includeLocationIntelligenceLinks: true,
        includeLocationCountryBriefLink: true,
        includeLocationCityBriefLink: true,
        type: 'DESTINATIONS',
      },
      {
        order: 6,
        type: 'DIVIDER',
      },
      {
        order: 7,
        type: 'HTML',
        html: 'Получавате това уведомление, защото организацията ви е избрала да получавате известия преди експедиране. За допълнителни въпроси относно това уведомление, моля, свържете се с екипа за управление на риска за чужденци на вашата организация или подайте искане за информация на <a href="mailto:support@crisis24.com">support@crisis24.com.</a>',
      },
    ],
  },
  [LOCALES.FR_CA]: {
    subject: "Avis préalable à l'expatriation",
    components: [
      {
        order: 1,
        type: 'TITLE',
        html: "Avis préalable à l'expatriation",
      },
      {
        order: 2,
        type: 'DIVIDER',
      },
      {
        order: 3,
        type: 'HTML',
        html: '<div><span class="customEmbed" data-key="First_Name" translate="no"><span contenteditable="false">&lt;First_Name&gt;</span></span>&nbsp;<span class="customEmbed" data-key="Last_Name" translate="no"><span contenteditable="false">&lt;Last_Name&gt;</span></span>,</div><div><br></div><div>Vous devez commencer une expatriation vers la destination ci-dessous. Veuillez consulter les derniers conseils pour cette destination ainsi que toutes les alertes actives.</div>',
      },
      {
        order: 4,
        type: 'EXPAT_ASSIGNMENT_DETAILS',
        includeExpatriationName: true,
        includeExpatriationStartDate: true,
        includeExpatriationEndDate: true,
      },
      {
        order: 5,
        html: 'Destinations: city, country',
        includeLocationIntelligenceLinks: true,
        includeLocationCountryBriefLink: true,
        includeLocationCityBriefLink: true,
        type: 'DESTINATIONS',
      },
      {
        order: 6,
        type: 'DIVIDER',
      },
      {
        order: 7,
        type: 'HTML',
        html: "Vous recevez cette notification parce que votre organisation vous a choisi de recevoir des avis préalables à l'expatriation. Pour d'autres questions au sujet de cet avis, veuillez communiquer avec l'équipe de gestion des risques des expatriés de votre organisation ou soumettre une demande d'information à <a href=\"mailto:support@crisis24.com\">support@crisis24.com</a>.",
      },
    ],
  },
  [LOCALES.EN_GB]: {
    subject: 'Pre Expatriation Notification',
    components: [
      {
        order: 1,
        type: 'TITLE',
        html: 'Pre Expatriation Notification',
      },
      {
        order: 2,
        type: 'DIVIDER',
      },
      {
        order: 3,
        type: 'HTML',
        html: '<div><span class="customEmbed" data-key="First_Name" translate="no"><span contenteditable="false">&lt;First_Name&gt;</span></span>&nbsp;<span class="customEmbed" data-key="Last_Name" translate="no"><span contenteditable="false">&lt;Last_Name&gt;</span></span>,</div><div><br></div><div>You are scheduled to begin an expatriation to the below destination. Please see the latest advice for this destination along with any active alerts.</div>',
      },
      {
        order: 4,
        type: 'EXPAT_ASSIGNMENT_DETAILS',
        includeExpatriationName: true,
        includeExpatriationStartDate: true,
        includeExpatriationEndDate: true,
      },
      {
        order: 5,
        html: 'Destinations: city, country',
        includeLocationIntelligenceLinks: true,
        includeLocationCountryBriefLink: true,
        includeLocationCityBriefLink: true,
        type: 'DESTINATIONS',
      },
      {
        order: 6,
        type: 'DIVIDER',
      },
      {
        order: 7,
        type: 'HTML',
        html: 'You are receiving this notification because your organization has opted you into receiving pre expatriation notifications. For further questions about this notification please contact your organization’s expatriate risk management team or submit request for information to <a href="mailto:support@crisis24.com">support@crisis24.com</a>.',
      },
    ],
  },
  [LOCALES.AR]: {
    subject: 'إشعار ما قبل الاغتراب',
    components: [
      {
        order: 1,
        type: 'TITLE',
        html: 'إشعار ما قبل الاغتراب',
      },
      {
        order: 2,
        type: 'DIVIDER',
      },
      {
        order: 3,
        type: 'HTML',
        html: '<div><span class="customEmbed" data-key="First_Name" translate="no"><span contenteditable="false">&lt;First_Name&gt;</span></span>&nbsp;<span class="customEmbed" data-key="Last_Name" translate="no"><span contenteditable="false">&lt;Last_Name&gt;</span></span>،</div><div><br></div><div>من المقرر أن تبدأ عملية الاغتراب إلى الوجهة أدناه. يرجى الاطلاع على أحدث النصائح لهذه الوجهة مع أي تنبيهات نشطة.</div>',
      },
      {
        order: 4,
        type: 'EXPAT_ASSIGNMENT_DETAILS',
        includeExpatriationName: true,
        includeExpatriationStartDate: true,
        includeExpatriationEndDate: true,
      },
      {
        order: 5,
        html: 'Destinations: city, country',
        includeLocationIntelligenceLinks: true,
        includeLocationCountryBriefLink: true,
        includeLocationCityBriefLink: true,
        type: 'DESTINATIONS',
      },
      {
        order: 6,
        type: 'DIVIDER',
      },
      {
        order: 7,
        type: 'HTML',
        html: 'أنت تتلقى هذا الإشعار لأن مؤسستك قد اختارتك لتلقي إشعارات ما قبل الاغتراب. لمزيد من الأسئلة حول هذا الإشعار، يُرجى الاتصال بفريق إدارة مخاطر الاغتراب في مؤسستك أو إرسال طلب للحصول على معلومات إلى <a href="mailto:support@crisis24.com">support@crisis24.com</a>.',
      },
    ],
  },
  [LOCALES.PT_BR]: {
    subject: 'Notificação antes da expatriação',
    components: [
      {
        order: 1,
        type: 'TITLE',
        html: 'Notificação antes da expatriação',
      },
      {
        order: 2,
        type: 'DIVIDER',
      },
      {
        order: 3,
        type: 'HTML',
        html: '<div><span class="customEmbed" data-key="First_Name" translate="no"><span contenteditable="false">&lt;First_Name&gt;</span></span>&nbsp;<span class="customEmbed" data-key="Last_Name" translate="no"><span contenteditable="false">&lt;Last_Name&gt;</span></span>,</div><div><br></div><div>Você está programado para iniciar uma expatriação para o destino abaixo. Consulte as recomendações mais recentes para esse destino, juntamente com todos os alertas ativos.</div>',
      },
      {
        order: 4,
        type: 'EXPAT_ASSIGNMENT_DETAILS',
        includeExpatriationName: true,
        includeExpatriationStartDate: true,
        includeExpatriationEndDate: true,
      },
      {
        order: 5,
        html: 'Destinations: city, country',
        includeLocationIntelligenceLinks: true,
        includeLocationCountryBriefLink: true,
        includeLocationCityBriefLink: true,
        type: 'DESTINATIONS',
      },
      {
        order: 6,
        type: 'DIVIDER',
      },
      {
        order: 7,
        type: 'HTML',
        html: 'Você está recebendo esta notificação porque sua organização optou por receber notificações pré-expatriação. Para obter mais informações sobre esta notificação, entre em contato com a equipe de gerenciamento de risco de expatriados da sua organização ou envie uma solicitação de informações para <a href="mailto:support@crisis24.com">support@crisis24.com</a>.',
      },
    ],
  },
  [LOCALES.SV]: {
    subject: 'Anmälan före utlandsvistelse',
    components: [
      {
        order: 1,
        type: 'TITLE',
        html: 'Anmälan före utlandsvistelse',
      },
      {
        order: 2,
        type: 'DIVIDER',
      },
      {
        order: 3,
        type: 'HTML',
        html: '<div><span class="customEmbed" data-key="First_Name" translate="no"><span contenteditable="false">&lt;First_Name&gt;</span></span>&nbsp;<span class="customEmbed" data-key="Last_Name" translate="no"><span contenteditable="false">&lt;Last_Name&gt;</span></span>,</div><div><br></div><div>Du är planerad att påbörja en utlandsvistelse till nedanstående destination. Vänligen se de senaste råden för denna destination tillsammans med eventuella aktiva varningar.</div>',
      },
      {
        order: 4,
        type: 'EXPAT_ASSIGNMENT_DETAILS',
        includeExpatriationName: true,
        includeExpatriationStartDate: true,
        includeExpatriationEndDate: true,
      },
      {
        order: 5,
        html: 'Destinations: city, country',
        includeLocationIntelligenceLinks: true,
        includeLocationCountryBriefLink: true,
        includeLocationCityBriefLink: true,
        type: 'DESTINATIONS',
      },
      {
        order: 6,
        type: 'DIVIDER',
      },
      {
        order: 7,
        type: 'HTML',
        html: 'Du får detta meddelande eftersom din organisation har valt att du ska få meddelanden före utlandsvistelse. För ytterligare frågor om detta meddelande, kontakta din organisations riskhanteringsteam för utlandsstationerade eller skicka en begäran om information till <a href="mailto:support@crisis24.com">support@crisis24.com</a>.',
      },
    ],
  },
  [LOCALES.FI]: {
    subject: 'Ennen maastapoistumista tehtävä ilmoitus',
    components: [
      {
        order: 1,
        type: 'TITLE',
        html: 'Ennen maastapoistumista tehtävä ilmoitus',
      },
      {
        order: 2,
        type: 'DIVIDER',
      },
      {
        order: 3,
        type: 'HTML',
        html: '<div><span class="customEmbed" data-key="First_Name" translate="no"><span contenteditable="false">&lt;First_Name&gt;</span></span>&nbsp;<span class="customEmbed" data-key="Last_Name" translate="no"><span contenteditable="false">&lt;Last_Name&gt;</span></span>,</div><div><br></div><div>Sinun on tarkoitus aloittaa ulkomaanmatka alla olevaan kohteeseen. Tutustu viimeisimpiin tätä kohdetta koskeviin neuvoihin ja mahdollisiin aktiivisiin kuulutuksiin.</div>',
      },
      {
        order: 4,
        type: 'EXPAT_ASSIGNMENT_DETAILS',
        includeExpatriationName: true,
        includeExpatriationStartDate: true,
        includeExpatriationEndDate: true,
      },
      {
        order: 5,
        html: 'Destinations: city, country',
        includeLocationIntelligenceLinks: true,
        includeLocationCountryBriefLink: true,
        includeLocationCityBriefLink: true,
        type: 'DESTINATIONS',
      },
      {
        order: 6,
        type: 'DIVIDER',
      },
      {
        order: 7,
        type: 'HTML',
        html: 'Saat tämän ilmoituksen, koska organisaatiosi on valinnut sinut vastaanottamaan maastamuuttoilmoituksia. Jos sinulla on lisäkysymyksiä tästä ilmoituksesta, ota yhteyttä organisaatiosi ulkomaankomennusriskien hallintaryhmään tai lähetä tietopyyntö osoitteeseen <a href="mailto:support@crisis24.com">support@crisis24.com</a>.',
      },
    ],
  },
  [LOCALES.DA]: {
    subject: 'Underretning før udstationering',
    components: [
      {
        order: 1,
        type: 'TITLE',
        html: 'Underretning før udstationering',
      },
      {
        order: 2,
        type: 'DIVIDER',
      },
      {
        order: 3,
        type: 'HTML',
        html: '<div><span class="customEmbed" data-key="First_Name" translate="no"><span contenteditable="false">&lt;First_Name&gt;</span></span>&nbsp;<span class="customEmbed" data-key="Last_Name" translate="no"><span contenteditable="false">&lt;Last_Name&gt;</span></span>,</div><div><br></div><div>Du er planlagt til at begynde en udstationering til nedenstående destination. Se venligst de seneste råd for denne destination sammen med eventuelle aktive advarsler.</div>',
      },
      {
        order: 4,
        type: 'EXPAT_ASSIGNMENT_DETAILS',
        includeExpatriationName: true,
        includeExpatriationStartDate: true,
        includeExpatriationEndDate: true,
      },
      {
        order: 5,
        html: 'Destinations: city, country',
        includeLocationIntelligenceLinks: true,
        includeLocationCountryBriefLink: true,
        includeLocationCityBriefLink: true,
        type: 'DESTINATIONS',
      },
      {
        order: 6,
        type: 'DIVIDER',
      },
      {
        order: 7,
        type: 'HTML',
        html: 'Du modtager denne meddelelse, fordi din organisation har valgt, at du skal modtage meddelelser før udstationering. For yderligere spørgsmål om denne meddelelse bedes du kontakte din organisations risikostyringsteam for udstationerede eller sende en anmodning om oplysninger til <a href="mailto:support@crisis24.com">support@crisis24.com</a>.',
      },
    ],
  },
  [LOCALES.NO]: {
    subject: 'Varsling før utvandring',
    components: [
      {
        order: 1,
        type: 'TITLE',
        html: 'Varsling før utvandring',
      },
      {
        order: 2,
        type: 'DIVIDER',
      },
      {
        order: 3,
        type: 'HTML',
        html: '<div><span class="customEmbed" data-key="First_Name" translate="no"><span contenteditable="false">&lt;First_Name&gt;</span></span>&nbsp;<span class="customEmbed" data-key="Last_Name" translate="no"><span contenteditable="false">&lt;Last_Name&gt;</span></span>,</div><div><br></div><div>Du skal etter planen begynne en utvandring til destinasjonen nedenfor. Se de siste rådene for denne destinasjonen sammen med eventuelle aktive varsler.</div>',
      },
      {
        order: 4,
        type: 'EXPAT_ASSIGNMENT_DETAILS',
        includeExpatriationName: true,
        includeExpatriationStartDate: true,
        includeExpatriationEndDate: true,
      },
      {
        order: 5,
        html: 'Destinations: city, country',
        includeLocationIntelligenceLinks: true,
        includeLocationCountryBriefLink: true,
        includeLocationCityBriefLink: true,
        type: 'DESTINATIONS',
      },
      {
        order: 6,
        type: 'DIVIDER',
      },
      {
        order: 7,
        type: 'HTML',
        html: 'Du mottar dette varselet fordi organisasjonen din har valgt at du mottar varsler før utvandring. For ytterligere spørsmål om dette varselet, vennligst kontakt organisasjonens utlendingsrisikostyringsteam eller send forespørsel om informasjon til <a href="mailto:support@crisis24.com">support@crisis24.com</a>.',
      },
    ],
  },
  [LOCALES.CA]: {
    subject: "Notificació prèvia a l'expatriació",
    components: [
      {
        order: 1,
        type: 'TITLE',
        html: "Notificació prèvia a l'expatriació",
      },
      {
        order: 2,
        type: 'DIVIDER',
      },
      {
        order: 3,
        type: 'HTML',
        html: '<div><span class="customEmbed" data-key="First_Name" translate="no"><span contenteditable="false">&lt;First_Name&gt;</span></span>&nbsp;<span class="customEmbed" data-key="Last_Name" translate="no"><span contenteditable="false">&lt;Last_Name&gt;</span></span>,</div><div><br></div><div>Està previst que comenceu una expatriació a la destinació següent. Si us plau, consulteu els últims consells per a aquesta destinació juntament amb qualsevol alerta activa.</div>',
      },
      {
        order: 4,
        type: 'EXPAT_ASSIGNMENT_DETAILS',
        includeExpatriationName: true,
        includeExpatriationStartDate: true,
        includeExpatriationEndDate: true,
      },
      {
        order: 5,
        html: 'Destinations: city, country',
        includeLocationIntelligenceLinks: true,
        includeLocationCountryBriefLink: true,
        includeLocationCityBriefLink: true,
        type: 'DESTINATIONS',
      },
      {
        order: 6,
        type: 'DIVIDER',
      },
      {
        order: 7,
        type: 'HTML',
        html: "Esteu rebent aquesta notificació perquè la vostra organització us ha optat per rebre notificacions prèvies a l'expatriació. Per a més preguntes sobre aquesta notificació poseu-vos en contacte amb l'equip de gestió de riscos expatriats de la vostra organització o envieu sol·licitud d'informació a <a href=\"mailto:support@crisis24.com\">support@crisis24.com</a>.",
      },
    ],
  },
  [LOCALES.ES_MX]: {
    subject: 'Notificación previa a la expatriación',
    components: [
      {
        order: 1,
        type: 'TITLE',
        html: 'Notificación previa a la expatriación',
      },
      {
        order: 2,
        type: 'DIVIDER',
      },
      {
        order: 3,
        type: 'HTML',
        html: '<div><span class="customEmbed" data-key="First_Name" translate="no"><span contenteditable="false">&lt;First_Name&gt;</span></span>&nbsp;<span class="customEmbed" data-key="Last_Name" translate="no"><span contenteditable="false">&lt;Last_Name&gt;</span></span>,</div><div><br></div><div>Está programado para comenzar una expatriación al siguiente destino. Consulte los últimos consejos para este destino junto con las alertas activas.</div>',
      },
      {
        order: 4,
        type: 'EXPAT_ASSIGNMENT_DETAILS',
        includeExpatriationName: true,
        includeExpatriationStartDate: true,
        includeExpatriationEndDate: true,
      },
      {
        order: 5,
        html: 'Destinations: city, country',
        includeLocationIntelligenceLinks: true,
        includeLocationCountryBriefLink: true,
        includeLocationCityBriefLink: true,
        type: 'DESTINATIONS',
      },
      {
        order: 6,
        type: 'DIVIDER',
      },
      {
        order: 7,
        type: 'HTML',
        html: 'Está recibiendo esta notificación porque su organización ha optado por recibir notificaciones previas a la expatriación. Si tiene más preguntas sobre esta notificación, comuníquese con el equipo de gestión de riesgos expatriados de su organización o envíe una solicitud de información a <a href="mailto:support@crisis24.com">support@crisis24.com</a>.',
      },
    ],
  },
};
